import { SelectionModel } from '@angular/cdk/collections';
import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import { ApiservicesService } from '../../../../apiservices.service';
import { UserTopComponent } from '../../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../../services/encryptdecrypt.service';


@Component({
  providers: [UserTopComponent],
  selector: 'app-penghantaran-e-borang',
  templateUrl: './penghantaran-e-borang.component.html',
  styleUrls: ['./penghantaran-e-borang.component.css']
})
export class PenghantaranEBorangComponent implements OnInit {
  //Session Variables
  SessionFirmID: any;
  SessionStaffID: any;
  SessionIDType: any;
  SessionIDNo: any;
  SessionAgentID: any;

  //UI Input Variables
  InputTaxRefNum: any = "";
  InputSignerPassword: any = "";

  //UI Temporary Variables
  TempTaxRefNum: any;
  TempStartDate: any;
  TempEndDate: any;
  TempSelected: any[]=[];

  //UI Status Varibles
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;
  SignButtonStatus: boolean = false;
  SelectAllStatus: boolean = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();
  selection = new SelectionModel(true, []);
  displayedColumns = ['select','taxpayername', 'tin', 'formtype' , 'registerdate', 'staffname', 'agentname'];
  RecordCount: any = "";

  //Modal Variables
  @ViewChild('signCloseButton') signCloseButton: any;
  @ViewChild('openResultModal') openResultModal: any;

  //Result Variable
  ResultView: any[]=[];
  TempToggleResult: any[] = [];

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
    this.SessionIDType = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDType') || ''));
    this.SessionIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.SessionAgentID = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || ''));
    this.SessionStaffID = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || ''));
    this.AirDatePickerInit();
    this.top.updateTotal();
  }
  AirDatePickerInit() {
    //const now = new Date();
    new AirDatepicker('#startdate', {
      locale: localeEn,
      dateFormat: "yyyy-MM-dd",
      //minDate: now,
      //isMobile: true,
    })
    new AirDatepicker('#enddate', {
      locale: localeEn,
      dateFormat: "yyyy-MM-dd",
      //minDate: now,
      //isMobile: true,
    })
  }
  Submit(TaxRefNum: any) {
    this.LoaderStatus = true;
    let startdate = document.getElementById('startdate') as HTMLInputElement | null;
    let enddate = document.getElementById('enddate') as HTMLInputElement | null;
    let Params = {};
    if (TaxRefNum === "" && (startdate?.value === "" || enddate?.value === "")) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (TaxRefNum !== "" && (startdate?.value === "" || enddate?.value === "")) {
      this.TempTaxRefNum = TaxRefNum;
      this.TempStartDate = null;
      this.TempEndDate = null;
      Params = {
        "SearchType": 1,
        "FirmID": this.SessionFirmID,
        "StaffID": this.SessionStaffID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "ITRefNo": String(TaxRefNum),
        "PageNum": 0,
        "PageSize": 10
      };
      this.GetData(Params);
    } else if (TaxRefNum === "" && (startdate?.value !== "" && enddate?.value !== "")) {
      this.TempTaxRefNum = null;
      this.TempStartDate = startdate?.value;
      this.TempEndDate = enddate?.value;
      Params = {
        "SearchType": 3,
        "FirmID": this.SessionFirmID,
        "StaffID": this.SessionStaffID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "DateFrom": startdate?.value,
        "DateTo": enddate?.value,
        "PageNum": 0,
        "PageSize": 10
      };
      this.GetData(Params);
    }
  }
  ViewAll() {
    this.TempTaxRefNum = null;
    this.TempStartDate = null;
    this.TempEndDate = null;
    let Params = {
      "SearchType": 0,
      "FirmID": this.SessionFirmID,
      "StaffID": this.SessionStaffID,
      "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
      "PageNum": 0,
      "PageSize": 10
    };
    this.GetData(Params);
    //this.SearchStatus = !this.SearchStatus;
  }
  async GetData(Params: any) {
    const result = await this.apiServices.GetListeDTS(Params);
    if (result.hasError) {
      this.dataSource = new MatTableDataSource();
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      result.eDTS.forEach((currentValue: any, index: any) => {
        result.eDTS[index].assignDate = formatDate(result.eDTS[index].assignDate, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        if (currentValue.signAccess)
          this.SelectAllStatus = true;
      });

      this.RecordCount = result.totalRecord;
      this.dataSource = new MatTableDataSource(result.eDTS);
      this.SearchStatus = true;
      this.LoaderStatus = false;
    }
  }
  paginatorEvent(e: PageEvent) {
    this.LoaderStatus = true;
    let tempSearchType;
    if (this.TempTaxRefNum !== null && (this.TempStartDate === null || this.TempEndDate === null))
      tempSearchType = 1;
    else if (this.TempTaxRefNum === null && (this.TempStartDate !== null && this.TempEndDate !== null))
      tempSearchType = 3;
    else
      tempSearchType = 0;

    let Params = {
      "SearchType": tempSearchType,
      "FirmID": this.SessionFirmID,
      "ITRefNo": this.TempTaxRefNum,
      "DateFrom": this.TempStartDate,
      "DateTo": this.TempEndDate,
      "PageNum": e.pageIndex,
      "PageSize": e.pageSize
    };
    this.GetData(Params);
  }
  Semula() {
    this.InputTaxRefNum = "";
    this.SearchStatus = false;
    this.LoaderStatus = false;
    this.SignButtonStatus = false;
    this.dataSource = new MatTableDataSource();
    this.RecordCount = "";
    this.selection.clear();
    (<HTMLInputElement>document.getElementById('startdate')).value = "";
    (<HTMLInputElement>document.getElementById('enddate')).value = "";
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  toggleAllRows(data: any) {
    this.TempToggleResult = [];
    if (this.isAllSelected()) {
      this.SignButtonStatus = false;
      this.selection.clear();
      return;
    }
    data.filteredData.forEach((currentValue: any, index: any) => {
      if (currentValue.signAccess)
        this.TempToggleResult.push(currentValue);
    });
    this.selection.select(...this.TempToggleResult);
    this.SignButtonStatus = true;
  }
  buttonToggle(row:any) {
    this.selection.toggle(row);

    if (this.selection.selected.length > 0)
      this.SignButtonStatus = true;
    else
      this.SignButtonStatus = false;
  }

  async Sign(Password: any) {
    this.TempSelected = [];
    this.ResultView = [];
    this.LoaderStatus = true;
    let tempParams = {};
    if (Password === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan kata laluan";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.selection.selected.forEach((currentValue: any, index: any) => {
        tempParams = {
          "TaxReturnFormID": this.selection.selected[index].taxReturnFormId,
          "dtlTaxReturnFormID": this.selection.selected[index].dtlTaxReturnFormId,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID,
          "AgentID": this.SessionAgentID,
          "TAPassword": Password,
          "TAIDType": this.SessionIDType
        };
        this.TempSelected.push(tempParams)
      });
      this.LoaderStatus = false;
      const result = await this.apiServices.SubmitDTS(this.TempSelected);
      result.forEach((currentValue: any, index: any) => {
        this.ResultView.push(result[index])
      });
      this.selection.clear();
      this.SignButtonStatus = false;
      this.InputSignerPassword = "";
      this.signCloseButton.nativeElement.click();
      this.openResultModal.nativeElement.click();
      this.ViewAll();
      this.LoaderStatus = false;
    }
  }
}
